import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import classes from './Heading.module.scss'

const Heading = ({ className, children, ...rest }) => {
  return (
    <div className={clsx('Heading', classes.root, className)} {...rest}>
      <div className={classes.spacerContainer}>
        <Icon icon="logo-square" prefix="ga" size={32} className={classes.spacer} />
      </div>
      <h2 className={classes.heading}>{children}</h2>
    </div>
  )
}

export default Heading
